// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__tVOEu","productName":"Table_productName__24xjC"};